import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { BillingFeature } from 'webapp/enums/enums';

export default class DesignerIndexRoute extends Route {
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	override beforeModel(): Promise<void> {
		return this.navigationService.initialRequestsPromise.then(() => {
			if (!this.billingService.checkIfCan(BillingFeature.BOARDS, true)) {
				this.navigationService.replaceRoute('index');
			} else {
				const record = this.mmBoardsService.createNewRecord();
				this.navigationService.transitionToRoute('designer.board', record);
			}
		});
	}
}
